export enum ReadStatus{
    Unread = 1,
    Read = 2
};